import { FoulTag } from './FoulTag';

// NBA live: IN (on the floor) or BENCH.
export const OnCourtTag = ({ leg }) => {
  if (leg.on_court == null || String(leg.performance_status || '').startsWith('FINAL')) return null;
  const inn = !!leg.on_court;
  return (
    <span className={`rounded px-1 text-[8px] font-black leading-[13px] tracking-wide ${inn ? 'bg-emerald-500 text-black' : 'bg-zinc-200 text-zinc-900'}`}
      data-testid={`on-court-${leg.id}`} title={inn ? 'On the floor right now' : 'On the bench right now'}>
      {inn ? 'IN' : 'BENCH'}
    </span>
  );
};

// Fouls + IN/BENCH on their own row so they never sit on top of the stat text.
export const LegTags = ({ leg }) => (
  <div className="mt-0.5 flex justify-end gap-1 empty:hidden" data-testid={`leg-tags-${leg.id}`}>
    <FoulTag leg={leg} />
    <OnCourtTag leg={leg} />
  </div>
);
